import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useListsStore } from '@stores/lists'
import { useDisciplineFilesStore } from '@stores/discipline-files'

import { MAX_PER_PAGE, toPaginationValue } from '@helpers/route'
import { foldBracketArrayParams } from '@helpers/query-params'
import {
  DISCIPLINE_FILES_ARRAY_QUERY_KEYS,
  getCanonicalDisciplineFilesQuery,
  queryToDisciplineFilesFilters,
} from '@helpers/discipline-files-query'

import { defineNuxtRouteMiddleware, navigateTo } from '#app'

/** `/disciplines/{id}/files` — query → store filters, as `middleware/surveys.ts` does. */
export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalizedGeneric) => {
  const foldedQuery = foldBracketArrayParams(to.query, DISCIPLINE_FILES_ARRAY_QUERY_KEYS)
  const query = foldedQuery ?? to.query

  const lists = await useListsStore().ensure()
  const filters = queryToDisciplineFilesFilters(query, lists?.file ?? null)
  const canonicalQuery = getCanonicalDisciplineFilesQuery(query, filters)

  if (foldedQuery || canonicalQuery) {
    return navigateTo({ path: to.path, query: canonicalQuery ?? query, hash: to.hash }, { replace: true })
  }

  const store = useDisciplineFilesStore()

  store.setFilters(filters)
  store.setCurrentPage(toPaginationValue(to.query?.page, 1))
  store.setPerPage(toPaginationValue(to.query?.per_page, store.getPerPage, MAX_PER_PAGE))
  store.closeModal()
})
